import React from "react";
import { useParams } from "react-router-dom";
import CategoryPurchase from "./Category/CategoryPurchase";
import CollectionPurchase from "./Collection/CollectionPurchase";
import SetsPurchase from "./Sets/SetsPurchase";

function PurchasePageWrapper() {
  const { purchase } = useParams();

  const renderPurchasePage = () => {
    switch (purchase) {
      case "Category-Purchased":
        return <CategoryPurchase />;
      case "Collection-Purchased":
        return <CollectionPurchase />;
      case "Sets-Purchased":
        return <SetsPurchase />;
      case "Partial-Sets-Purchased":
        return <SetsPurchase isPartial={true} />;
      default:
        return <div style={{ color: "yellow" }}>PurchasePageWrapper</div>;
    }
  };

  return <>{renderPurchasePage()}</>;
}

export default PurchasePageWrapper;
